import Checkout from './Checkout-compose';

export default Checkout;
